{
    "6b581fdc-13f5-48a7-b45c-82834cf95a18": {
        "affiliation": "bad",
        "key": "6b581fdc-13f5-48a7-b45c-82834cf95a18",
        "position": {
            "x": 8,
            "y": 7,
            "z": 1
        },
        "level": 1,
        "faceKey": "human",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic"
    },
    "160c2901-d6a5-4d9d-a0b2-744f69446d2f": {
        "affiliation": "bad",
        "key": "160c2901-d6a5-4d9d-a0b2-744f69446d2f",
        "position": {
            "x": 11,
            "y": 3,
            "z": 1
        },
        "level": 1,
        "faceKey": "human",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic"
    },
    "3f4ea1ba-cdf6-42e8-8720-2eb7faa93c7b": {
        "affiliation": "bad",
        "key": "3f4ea1ba-cdf6-42e8-8720-2eb7faa93c7b",
        "position": {
            "x": 8,
            "y": 3,
            "z": 1
        },
        "level": 1,
        "faceKey": "human",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic"
    },
    "a0bd3767-3f3b-4bb2-9421-db72566ffd46": {
        "affiliation": "bad",
        "key": "a0bd3767-3f3b-4bb2-9421-db72566ffd46",
        "position": {
            "x": 11,
            "y": 7,
            "z": 1
        },
        "level": 1,
        "faceKey": "human",
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic"
    },
    "mercenary": {
        "key": "mercenary",
        "position": {
            "x": 9,
            "y": 5,
            "z": 1
        },
        "templateKey": "player/mercenary"
    },
    "cabinboy": {
        "key": "cabinboy",
        "position": {
            "x": 10,
            "y": 5,
            "z": 1
        },
        "templateKey": "player/cabinboy"
    },
    "captain": {
        "key": "captain",
        "position": {
            "x": 9,
            "y": 4,
            "z": 1
        },
        "templateKey": "player/captain"
    },
    "missionary": {
        "key": "missionary",
        "position": {
            "x": 10,
            "y": 4,
            "z": 1
        },
        "templateKey": "player/missionary"
    }
}
